import { IconClose16, IconShare16 } from '@warp-ds/icons/react';
import { Button } from '@warp-ds/react';
import React, { useState } from 'react';
import { ShareAd } from './ShareAd';

type ActionBarProps = {
    className?: string;
    itemId: number;
    isMobile?: boolean;
    userId?: string | number;
    favoriteHeartButton?: JSX.Element;
    isFullScreen?: boolean;
    title?: string;
    onClose: () => void;
};

export const ActionBar = ({ itemId, isMobile = false, onClose, title, className, isFullScreen, favoriteHeartButton }: ActionBarProps) => {
    const [shareOpen, setShareOpen] = useState(false);
    const toggleShareModal = async () => {
        setShareOpen(!shareOpen);
    };

    const baseClasses = '!p-8 flex justify-center items-center !min-h-[34px] !min-w-[34px] !max-h-[34px] !max-w-[34px]';
    const galleryClasses =
        '!rounded-full !border-0 !bg-[var(--w-gray-750)] !hover:bg-[var(--w-gray-700)] !active:bg-[var(--w-gray-600)] s-icon-inverted hover:s-icon-inverted-hover';
    const normalClasses = '!rounded-4 shadow-s !hover:s-bg-primary-subtle-hover !s-bg hover:s-icon-hover';
    const buttonClasses = `${baseClasses} ${isFullScreen ? galleryClasses : normalClasses}`;

    return (
        <>
            <div className={`${className}`}>
                {favoriteHeartButton &&
                    React.cloneElement(favoriteHeartButton, {
                        buttonClass: buttonClasses,
                    })}
                <Button
                    quiet
                    utility
                    className={buttonClasses}
                    onClick={() => toggleShareModal()}
                    aria-label={'del'}
                    data-testid="share-ad-details">
                    <IconShare16 strokeWidth={1.5} />
                </Button>
                {isFullScreen && !isMobile && (
                    <Button
                        quiet
                        utility
                        aria-label="Lukk gallerivisning"
                        className={buttonClasses}
                        onClick={() => {
                            onClose();
                        }}>
                        <IconClose16 strokeWidth={1.5} />
                    </Button>
                )}
            </div>
            {shareOpen && (
                <div className="fixed inset-0 z-30">
                    <ShareAd adId={itemId} title={title} open={shareOpen} toggleModal={toggleShareModal} />
                </div>
            )}
        </>
    );
};
